export default "__VITE_ASSET__v5RnSwxp__"